import {useEffect, useState} from 'react';
import {flagLoaders, FlagLoader} from './flags';

const normalizeCode = (code?: string) =>
  code ? code.toLowerCase().replace(/-/g, '_') : '';

const flagSrcCache: Record<string, string> = {};
const pendingLoads: Record<string, Promise<string>> = {};

const loadFlagSrc = async (code?: string) => {
  const key = normalizeCode(code);
  if (!key) return '';
  if (flagSrcCache[key]) return flagSrcCache[key];
  if (!pendingLoads[key]) {
    const loader: FlagLoader | undefined = flagLoaders[key];
    pendingLoads[key] = loader
      ? loader().then((module: {default: string}) => {
          flagSrcCache[key] = module.default;
          return flagSrcCache[key];
        })
      : Promise.resolve('');
  }
  return pendingLoads[key];
};

export const useFlagImage = (code?: string) => {
  const [src, setSrc] = useState<string | undefined>(() =>
    code ? flagSrcCache[normalizeCode(code)] : undefined,
  );

  useEffect(() => {
    let mounted = true;
    if (!code) return undefined;
    const key = normalizeCode(code);
    if (flagSrcCache[key]) {
      setSrc(flagSrcCache[key]);
      return undefined;
    }
    loadFlagSrc(code).then((result) => {
      if (mounted) {
        setSrc(result || undefined);
      }
    });
    return () => {
      mounted = false;
    };
  }, [code]);

  return src;
};
